import {
  tableColumnsMap,
} from '@op/pages/Influencer/constants';
import { dealwithChannel, dealwithCoutry, dealwithLanguage } from '../../render-helper';
import { DBO_T } from '@op/utils/format';

export default function influencerColumns(params: any) {
  const { extraParams } = params || {};
  const optionsMap = extraParams?.tagList;

  let media_type =
    params.media_types.length > 1 ? 'sum' : params.media_types[0];

  let commonColumns = [
    { render: 'user_name', header: 'Influencer' },
    { render: 'channel', header: 'Channel', renderHelper: [dealwithChannel] },
    { render: 'country', header: 'Country', renderHelper: [dealwithCoutry] },
    {
      render: 'language',
      header: 'Language',
      renderHelper: [dealwithLanguage],
    },
    { render: 'url', header: 'URL' },
    {
      render: 'tags',
      header: 'Tags',
      renderHelper: [
        (item: any, key: string) => {
          const tags = item[key]
            .map((labelKey: string) => {
              const tagName = labelKey.replace('is_', '').replaceAll('_', '-');
              const { downloadText: text } = optionsMap[tagName] || {};
              return text || '';
            })
            .join(', ');

          const extraTags = item['ext_tags']
            ?.map((tag) => {
              const { name, tags } = tag;
              const itemInfo = optionsMap[name];
              if (!itemInfo) return '';
              const { downloadText: text } = itemInfo;
              const gameList = tags.map((tag: any) => tag.game).join(', ');
              if (gameList) {
                return `${text} (${gameList})`;
              }
              return text || '';
            })
            .join(', ');

          const allTags = [tags, extraTags]
            .filter(Boolean)
            .join(', ')
            .replace(/,\s*$/, ''); // ✅ remove trailing comma safely

          return allTags;
        },
      ],
    },
  ];

  const targetColumns = tableColumnsMap[media_type].map((item: any) => {
    if (item.showChart) {
      return ['total', 'text', 'image', 'video'].map((subKey) => {
        const key = `${subKey}_${item.key}`;

        const itemColumns: any = {
          render: key,
          header: item.header + '_' + DBO_T.upperFirst(subKey),
        };

        if (item.numFmt) {
          itemColumns.numFmt = item.numFmt;
        }

        return itemColumns;
      });
    }

    const curColumn: any = { render: item.key, header: item.header };
    if (item.numFmt) {
      curColumn.numFmt = item.numFmt;
    }
    return curColumn;
  });

  return [...commonColumns, ...targetColumns.flat(3)];
}
